import { Badge } from '@commenda/kakashi';
import { WorkflowTemplateVersionStatus } from '@prisma/client';
import { WorkflowTemplateHelper } from './helpers';

export const WorkflowTemplateVersionStatusBadge = ({
  status,
}: {
  status: WorkflowTemplateVersionStatus;
}) => {
  const { variant, text } =
    WorkflowTemplateHelper.WorkflowTemplateVersionStatusBadgeVariantMap[status];
  return (
    <Badge variant={variant} size="sm">
      {text}
    </Badge>
  );
};
